import { pxToRem } from '../../utils';
var formStyles = {
    root: function (_a) {
        var props = _a.props, variables = _a.variables;
        return ({
            height: '100%',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: '1fr',
            justifyContent: 'space-evenly',
            gridGap: pxToRem(20),
            justifyItems: 'start',
        });
    },
};
export default formStyles;
